import React, { useState } from 'react';
import { Modal, Box, TextField, Button, Typography, IconButton} from '@mui/material';
import { ModalBox } from '../../../styles/ModalStyles';
import CloseIcon from '@mui/icons-material/Close';
const NuevoTipoDocumentoModal = ({ open, onClose, onSubmit }) => {
  const [nombre, setNombre] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ nombre });
    setNombre('');
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalBox>
      <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      <Typography variant='h6'>Nuevo Tipo de Documento</Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Nombre"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            margin="normal"
            required
          />
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <Button type="submit" variant="contained" color="primary" sx={{ mr: 1 }}>
            Guardar
          </Button>
          <Button onClick={onClose} variant="contained" color="error" >
            Cancelar
          </Button>
          </Box>
        </form>
      </ModalBox>
    </Modal>
  );
};

export default NuevoTipoDocumentoModal;